module.exports = __webpack_public_path__ + "static/media/stripe.36c1d377.svg";